import * as React from "react";
import { format } from "date-fns";
import { get } from "lodash";
import { ListBox } from "primereact/listbox";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import {
	getUserCertificates,
	Certificate,
	createDetachedSignature,
	createHash,
	getSystemInfo,
} from "./crypto-pro-module/crypto-pro";

import Field from "../components/Field";
import ErrorAlert from "../components/ErrorAlert";

import { Component, createFile, Guid, replacer } from "../../helpers/Utils";
import { IControlError, IControlSchema } from "../../../core/Controls";
import { IDispatcher } from "../../helpers/Dispatcher";

import ApiClientModule from "../../../services/ApiClientModule";
import MultipleFiles from "../MultipleFiles";

// TODO: Need refactoring and types
class SigCreatorFromFile extends Component<any, any> {
	state = {
		signed: false,
		certificates: null,
		certificate: null,
		status: [],
		files: {
			pdf: null,
			sig: null,
		},
	};

	constructor(props) {
		super(props);
		this.getError = this.getError.bind(this);
		this.handlerChangeCertificate = this.handlerChangeCertificate.bind(this);
		this.pushState = this.pushState.bind(this);
		this.signFile = this.signFile.bind(this);
		this.getPdfFile = this.getPdfFile.bind(this);
		this.getCertificates = this.getCertificates.bind(this);
		this.handlerChangeCertificate = this.handlerChangeCertificate.bind(this);
		this.setError = this.setError.bind(this);
	}

	async componentDidMount() {
		const { dispatcher, schema } = this.props;
		dispatcher.controlVisited(schema.id);

		const pdf = dispatcher.pullValue(`${schema.id}_file`);
		const sig = dispatcher.pullValue(`${schema.id}_sig`);

		if (!pdf || !sig) {
			await this.clearFile();
			await this.getCertificates();
		} else {
			this.setState({
				signed: true,
				files: {
					pdf,
					sig
				}
			});
		}

		// Если файлы уже лежат, значит подпись происходила, и все шаги надо отобразить
		if (dispatcher.pullValue(`${schema.id}_sig`)) {
			this.setState({
				status: [
					{
						message: "Загрузка сертификатов",
						loading: false,
					},
					{
						message: "Выбор сертификата",
						loading: false,
					},
					{
						message: "Получение файла",
						loading: false,
					},
					{
						message: "Подпись файла",
						loading: false,
					},
				],
			});
		}
	}

	getError = () => {
		const { error, visited, value } = this.props;
		const errorText = visited && error?.message;

		let className = "default";
		if (value && !errorText) {
			className = "success";
		} else if (errorText) {
			className = "error";
		}

		return {
			className,
			errorText,
		};
	};

	setError(title, message) {
		this.props.dispatcher.setError(
			this.props.schema.id,
			undefined,
			{
				message: title,
			},
			true
		);
		this.props.dispatcher.notify(message);
	}

	/*
	 * Подписывает файлы в base64, возвращает подпись файлом или текстом
	 * */

	/*
	 * Возвращает список сертификатов
	 * */
	getCertificates = async () => {
		let certificates: Certificate[] | any;
		this.pushState({
			message: "Загрузка сертификатов",
			loading: true,
		});

		try {
			await getSystemInfo();
			try {
				certificates = await getUserCertificates();
				// eslint-disable-next-line guard-for-in
				for (const key in certificates) {
					// eslint-disable-next-line no-await-in-loop
					certificates[key].extra = await certificates[key].getOwnerInfo();
				}

				this.pushState(
					{
						message: "Загрузка сертификатов",
						loading: false,
					},
					{
						certificates,
					}
				);
				this.pushState({
					message: "Выбор сертификата",
					loading: true,
				});
			} catch (error) {
				this.setError("В системе не нашлись сертификаты", <p>В системе не нашлись сертификаты</p>);
			}
		} catch (error) {
			this.setError(
				"Не установлен плагин",
				<>
					<p>Не установлен плагин</p>
					<p>
						Инструкцию по установке и настройке плагина можно получить по адресу:&nbsp;
						<a href="https://www.cryptopro.ru/products/cades/plugin">https://www.cryptopro.ru/products/cades/plugin</a>
					</p>
				</>
			);
		}
	};

	/*
	 * Обработчик выбора сертификата
	 * */
	handlerChangeCertificate = (e) => {
		const { certificates } = this.state;
        const certificate = certificates.find((item) => item.thumbprint === e.value);

		this.pushState(
			{
				message: "Выбор сертификата",
				loading: false,
			},
			{
				certificate,
			}
		);
	};

	/*
	 * Получение файла
	 * */
	async getPdfFile(): Promise<any> {
		const { fileLocationUrl } = this.props.schema;
		const { certificates } = this.state;

		if (!certificates?.length) {
			await this.getCertificates();
		}

		await this.clearFile();

		return new Promise((resolve, reject) => {
			try {
				// Инициирую api
				// Создаю строку с URL откуда забирать файл
				this.pushState({
	          message: "Получение файла",
	          loading: true,
          },
        {
          files: {
						pdf: null,
            sig: null,
					}
        });

				const apiClientModule = new ApiClientModule();
				const sourceObject = Object.keys(fileLocationUrl.pathFromProps).reduce((acc, index) => {
					const item = fileLocationUrl.pathFromProps[index];
					return {
						...acc,
						[index]: get(this.props, item),
					};
				}, {});
				const result = replacer(fileLocationUrl.url, sourceObject);

				// Пытаюсь забрать файл
				apiClientModule.getFileArrayBuffer(
					result,
					{},
					{
						success: async (response) => {
							const arrayBuffer = response.data;
							const base64 = `data:application/pdf;base64,${Buffer.from(arrayBuffer).toString("base64")}`;

							this.pushState(
								{
									message: "Получение файла",
									loading: false,
								},
								{
									files: {
										...this.state.files,
										pdf: {
											id: Guid.newGuid(),
											url: base64,
											value: "file.pdf",
											isLoader: false,
											isBase64: true,
											arrayBuffer,
										},
									},
								}
							);

							resolve({
								id: Guid.newGuid(),
								url: base64,
								value: "file.pdf",
								isLoader: false,
								isBase64: true,
								arrayBuffer,
							});

							return response;
						},
						error: ({ response }) => {
							/* if(!response?.data?.pd_field_errors) {
                            this.setError('Не удалось получить подписываемый файл', <>
                                <p>Не удалось получить подписываемый файл</p>
                            </>);
                        }*/
							const json = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(response.data)));
							this.props.dispatcher.setErrors(json.field_errors);
							reject(json.field_errors);
						},
					}
				);
			} catch (error) {
				this.setError("Ошибка получения файла", <p>Ошибка получения файла</p>);
				reject(error);
			}
		});
	}

	pushState = async (data: { message: string; loading: boolean }, state = {}) => {
		const foundStatusIndex = this.state.status.findIndex((item) => item.message === data.message);
		if (foundStatusIndex >= 0) {
			this.setState(({ status }) => ({
				status: status.map((item, index) => {
					if (index === foundStatusIndex) {
						return data;
					}
					return item;
				}),
				...state,
			}));
		} else {
			this.setState(({ status }) => ({
				status: [...status, data],
				...state,
			}));
		}

		return Promise.resolve();
	};

	customDeleteFile = (type: "pdf" | "sig") => async () => {
		const { certificates } = this.state;

		this.setState({ signed: false });

		// TODO: DRY!
		if (type === "sig") {
			this.setState(({ files }) => ({
				files: {
					...files,
					sig: null
				},
				status: [
					{ message: "Загрузка сертификатов", loading: false },
					{ message: "Выбор сертификата",	loading: false },
					{ message: "Получение файла",  loading: false },
				]
			}));
		}
		if (type === "pdf") {
			this.setState(({ certificate }) => ({
				status: [
					{ message: "Загрузка сертификатов", loading: false },
					{ message: "Выбор сертификата", loading: !certificate }
				]
			}));
		}

		if (!certificates) {
			await this.getCertificates();
		}
	};

	clearFile = async () => {
		const { api, schema, dispatcher } = this.props;
		const file = dispatcher.pullValue(`${schema.id}_file`);
		const sig = dispatcher.pullValue(`${schema.id}_sig`);

		try {
			// TODO: DRY!!!
			if (Array.isArray(sig?.inputs)) {
				const { id, value } = sig.inputs[0];
				await api.deleteFileValue(`${schema.id}_sig`, value, "", id, {
					success: async () => {
						await dispatcher.onLoadFile(`${schema.id}_sig`, null);
					}
				});
			}

			if (Array.isArray(file?.inputs)) {
				const { id, value } = file.inputs[0];
				await api.deleteFileValue(`${schema.id}_file`, value, "", id, false, {
					success: async () => {
						await dispatcher.onLoadFile(`${schema.id}_file`, null);
					}
				});
			}
		} catch (error) {
			console.log(error);
		} finally {
			console.log("finish");
		}
	};

	updateSigWithOldPdf = async (arrayBuffer) => {
		const { certificate } = this.state;
		const hash = await createHash(arrayBuffer);
		const sign = await createDetachedSignature(certificate.thumbprint, hash);

		this.pushState(
			{
				message: "Подпись файла",
				loading: false,
			},
			{
				signed: true,
				files: {
					...this.state.files,
					sig: {
						id: Guid.newGuid(),
						url: createFile(sign),
						value: "file.sig",
						isLoader: false,
						isBase64: true,
					},
				},
			}
		).then(() => {
			this.props.dispatcher.setError(this.props.schema.id, undefined, undefined, undefined);
			this.props.dispatcher.notify("Файл успешно подписан");

			if (this.props.schema?.extra?.isRefreshForm) {
				setTimeout(() => {
					this.props.dispatcher.onUpdateForm(this.props.schema.id);
				}, 1000);
			}
		});
	};

	async signFile() {
		const {
			certificate,
			files: {
				pdf: { arrayBuffer },
			},
		} = this.state;

		this.pushState({
			message: "Подпись файла",
			loading: true,
		});

		if (!certificate?.thumbprint) {
			this.setError(
				"Ошибка при подписании файла",
				<p style={{ whiteSpace: "pre" }}>Выберите сертификат</p>
			);

			return;
		}

		try {
			if (!arrayBuffer) {
				const { files: { pdf } } = this.state;
				const apiModule = new ApiClientModule();

				await apiModule.getFileByUrl(pdf.inputs?.[0].url,  "arraybuffer", {
					success: async ({ data }) => {
						await this.updateSigWithOldPdf(data);

						return data;
					}
				});
			} else {
				await this.updateSigWithOldPdf(arrayBuffer);
			}
		} catch (error) {
			let message = "";

			if (certificate === null) {
				message = "Не выбран сертификат";
			} else if (error.message) {
				message = `${error.message}\n\nДля подробной информации обратитесь к разработчику`;
			} else {
				message = "Ошибка при подписании файла";
			}
			this.setState({ signed: false });
			this.setError(
				"Ошибка при подписании файла",
				<p style={{ whiteSpace: "pre" }}>{message}</p>
			);
		}
	}

	public render() {
		const { schema, api, dispatcher, error } = this.props;
		const {
			certificates,
			certificate,
			status,
			signed,
			files: { pdf, sig },
		} = this.state;
		const { className, errorText } = this.getError();

		return (
			<Field {...this.props.schema} status={className}>
				<div className="certificates">
					<p>Каким сертификатом подписать файл?</p>
					<div className="certificates__list">
						{/* TODO */}
						{/* @ts-ignore */}
						<ListBox
							optionLabel="name"
							optionValue="thumbprint"
							options={certificates}
							value={certificate?.thumbprint}
							// disabled={schema.disabled}
							itemTemplate={(option) => (
								<div>
									<h5>Сертификат {option.name}</h5>
									<h6>{option.extra[0].title}: {option.extra[0].description}</h6>
									<h6>Действителен до: {format(new Date(option.validTo), "dd.MM.yyyy")}</h6>
								</div>
							)}
							onChange={this.handlerChangeCertificate}
						/>
					</div>
				</div>

				{/* TODO */}
				{/* @ts-ignore */}
				<Divider />

				<div className="status">
					{/* TODO */}
					{/* @ts-ignore */}
					<Card className="status__list">
						{/* TODO */}
						{/* @ts-ignore */}
						<Timeline
							value={status}
							align="left"
							content={(item) => item.message}
							marker={(item) => (
								<div
									className="p-timeline-event-marker"
									style={{ backgroundColor: item.loading ? "#f0ad4e" : "#5cb85c", border: "unset" }}
								/>
							)}
						/>
					</Card>
				</div>

				{/* TODO */}
				{/* @ts-ignore */}
				<Divider />
				<div className="sig-file">
					<MultipleFiles
						schema={{
							...schema,
							title: {
								ru: "Файл для подписи",
								en: "Файл для подписи",
							},
							id: `${schema.id}_file`,
							disabled: true,
							activeDeleteBtn: true,
							value: dispatcher.pullValue(`${schema.id}_file`) ?? (pdf ? { inputs: [pdf] } : null),
						}}
						api={api}
						dispatcher={dispatcher}
						error={error}
						someProperties={{
							customDelete: this.customDeleteFile("pdf")
						}}
					/>

					{dispatcher.pullValue(`${schema.id}_file`) ? (
						<MultipleFiles
							schema={{
								...schema,
								title: {
									ru: "Открепленная подпись",
									en: "Открепленная подпись",
								},
								id: `${schema.id}_sig`,
								disabled: true,
								activeDeleteBtn: true,
								value: dispatcher.pullValue(`${schema.id}_sig`) ?? (sig ? { inputs: [sig] } : null),
							}}
							api={api}
							dispatcher={dispatcher}
							error={error}
							someProperties={{
								customDelete: this.customDeleteFile("sig")
							}}
						/>
					) : null}
				</div>

				{/* TODO */}
				{/* @ts-ignore */}
				<Divider />

				{dispatcher.pullValue(`${schema.id}_file`) ? (
					// @ts-ignore
					// TODO
					<Button
						label="Подписать"
						type="button"
						onClick={this.signFile}
						disabled={schema.disabled || signed}
					/>
				) : (
					// @ts-ignore
					// TODO
					<Button
						label="Получить файл для подписи"
						type="button"
						onClick={this.getPdfFile}
						// disabled={schema.disabled}
					/>
				)}
				<ErrorAlert errorMessage={errorText} />
			</Field>
		);
	}
}

export const createSigCreatorFromFile = (
	schema: IControlSchema,
	api: any,
	dispatcher: IDispatcher = null,
	error: IControlError | undefined,
	visited: boolean
): React.ReactElement<any> => (
	<SigCreatorFromFile
		schema={schema as IControlSchema}
		api={api}
		dispatcher={dispatcher}
		error={error}
		visited={visited}
	/>
);
